/* eslint-disable jsx-a11y/control-has-associated-label */
import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import $ from 'jquery';
import 'select2';
import './OrgSelect.scss';

const OrgSelect = ({
  htmlClass,
  htmlId,
  htmlName,
  onChange,
  selected,
}) => {
  const [loading, setLoading] = useState(false);
  const [selectedOrg, setSelectedOrg] = useState(null);
  const el = useRef(null);

  useEffect(() => {
    if (selected) {
      setLoading(true);
      $.get(`/api/organizations/${selected}`)
        .done(({ orgCode, name }) => {
          setSelectedOrg({
            id: orgCode,
            text: `${name} (${orgCode})`,
          });
          setLoading(false);
          onChange();
        });
    }

    $(el.current).select2({
      allowClear: true,
      ajax: {
        url: '/api/organizations/search',
        processResults: results => ({ results }),
      },
      minimumInputLength: 3,
      placeholder: 'Select an organization',
    }).on('change', onChange);
  }, [selected]);

  return (
    <div className="orgselect-root">
      {loading && <div className="orgselect-loading">Loading...</div>}

      <select
        className={htmlClass}
        id={htmlId}
        name={htmlName}
        ref={el}
      >
        {selectedOrg && (
          <option value={selectedOrg.id}>
            {selectedOrg.text}
          </option>
        )}
      </select>
    </div>
  );
};

OrgSelect.propTypes = {
  htmlClass: PropTypes.string,
  htmlId: PropTypes.string,
  htmlName: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  selected: PropTypes.string,
};

OrgSelect.defaultProps = {
  htmlClass: '',
  htmlId: '',
  onChange: () => false,
  selected: null,
};

export default OrgSelect;
